module.exports = new Promise(function (resolve, reject) {
    var __webpack_error__ = new Error();

    if (typeof window["backpack"] !== 'undefined') {
      return resolve();
    }

    __webpack_require__.l(
      window["backpackRemoteUrl"] + '/remote-entry-backpack.js',
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
           return resolve();
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "backpack",
    );
  }).then(function(){
    var proxy = {
      get: window["backpack"].get,
      init: window["backpack"].init
    }
    return proxy
  }).catch(function(e) {
    console.error('backpack', e);
    let newProxy = {
      get: (module, scope) => () => [],
      init: () => {}
    }
    return(newProxy);
  });